const Z = ({
  m: e,
  margin: a,
  marginBlock: o,
  marginBlockEnd: p,
  marginBlockStart: r,
  marginBottom: s,
  marginEnd: t,
  marginInline: c,
  marginInlineEnd: x,
  marginInlineStart: f,
  marginLeft: g,
  marginRight: h,
  marginStart: k,
  marginTop: l,
  marginX: n,
  marginY: C,
  mb: P,
  me: b,
  ml: d,
  mr: i,
  ms: j,
  mt: m,
  mx: q,
  my: u,
  p: v,
  padding: w,
  paddingBlock: y,
  paddingBlockEnd: z,
  paddingBlockStart: A,
  paddingBottom: B,
  paddingEnd: D,
  paddingInline: E,
  paddingInlineEnd: F,
  paddingInlineStart: G,
  paddingLeft: H,
  paddingRight: I,
  paddingStart: J,
  paddingTop: K,
  paddingX: L,
  paddingY: M,
  pb: N,
  pe: O,
  pl: Q,
  pr: R,
  ps: S,
  pt: T,
  px: U,
  py: V,
  flex: W,
  order: X,
  ...Y
}) => ({
  space: {
    m: e,
    margin: a,
    marginBlock: o,
    marginBlockEnd: p,
    marginBlockStart: r,
    marginBottom: s,
    marginEnd: t,
    marginInline: c,
    marginInlineEnd: x,
    marginInlineStart: f,
    marginLeft: g,
    marginRight: h,
    marginStart: k,
    marginTop: l,
    marginX: n,
    marginY: C,
    mb: P,
    me: b,
    ml: d,
    mr: i,
    ms: j,
    mt: m,
    mx: q,
    my: u,
    p: v,
    padding: w,
    paddingBlock: y,
    paddingBlockEnd: z,
    paddingBlockStart: A,
    paddingBottom: B,
    paddingEnd: D,
    paddingInline: E,
    paddingInlineEnd: F,
    paddingInlineStart: G,
    paddingLeft: H,
    paddingRight: I,
    paddingStart: J,
    paddingTop: K,
    paddingX: L,
    paddingY: M,
    pb: N,
    pe: O,
    pl: Q,
    pr: R,
    ps: S,
    pt: T,
    px: U,
    py: V
  },
  flex: {
    flex: W,
    order: X
  },
  ...Y
});
export {
  Z as getChakraProps
};
//# sourceMappingURL=props.es.js.map
